import Accounts from '../accounts';
import FormDetails from '../form-details';
import Forms from '../forms';
import Profile from '../profile/profile';
import TemplateDetails from '../template-details';
import TemplateEditor from '../template-editor';
import Templates from '../templates';
export const ROUTE_PATHS = [
  {
    id: 3,
    path: '/forms',
    Component: Forms,
    permission: ['FORMS_VIEW'],
  },
  {
    id: 7,
    path: '/profile',
    Component: Profile,
  },
  {
    id: 17,
    path: '/forms/:id/*',
    Component: FormDetails,
    permission: ['FORMS_VIEW'],
  },
  {
    id: 20,
    path: '/accounts',
    Component: Accounts,
  },
  {
    id: 21,
    path: '/templates',
    Component: Templates,
    permission: ['FORMS_VIEW'],
  },
  {
    id: 22,
    path: '/templates/:id/versions',
    Component: TemplateDetails,
    permission: ['FORMS_VIEW'],
  },
  {
    id: 23,
    path: '/templates/:id/versions/:versionId',
    Component: TemplateEditor,
    permission: ['FORMS_VIEW'],
  },
];
